import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Swal from "sweetalert2";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Spin } from "antd";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { RotateCcw } from "feather-icons-react/build/IconComponents";

const RejoinEmployeeList = () => {
  const [data, setData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];

    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchEmployees = async () => {
    setDataLoading(true);

    if (!tokenData || !superIdData) {
      setDataLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/termination/getTerminatedlist?superid=${superIdData}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      const data = await response.json();
      console.log(data);

      if (data.status) {
        setData(data.ResultData);
      } else {
        console.error(
          "Failed to fetch employees:",
          data.ErrorMsg || response.statusText,
        );
      }
    } catch (error) {
      console.error("Error fetching employees:", error.message);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [tokenData, superIdData]);

  const filteredData = data.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.BIOMetricId && item.BIOMetricId.toString()) ||
      (item.Designation && item.Designation.toString()) ||
      (item.Reason && item.Reason.toLowerCase())
    );
  });

  const handleRejoinEmp = async (regID) => {
    if (tokenData) {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/termination/rejoinEmp`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify({
              regid: regID,
            }),
          },
        );

        const data = await response.json();

        if (data.status) {
          Swal.fire({
            title: "Success",
            text: "Employee Rejoined sucessfully",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              // window.location.reload();
              fetchEmployees();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error Occured while Rejoining Employee:", error.message);
      }
    }
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData?.map((item, index) => ({
      "S.No": index + 1,
      "Biometric ID": item.BIOMetricId || "N/A",
      Name: item.UserName || "N/A",
      Designation: item.Designation || "N/A",
      Date: item.TerminationDt || "N/A",
      Reason: item.Reason || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee Termination");
    XLSX.writeFile(wb, "Employee_Termination.xlsx");
  };

  const generatePDF = () => {
    if (!filteredData || filteredData.length === 0) return;

    const doc = new jsPDF();

    const generatedDate = new Date().toLocaleString();

    const tableColumn = [
      "S.No",
      "Biometric ID",
      "Name",
      "Designation",
      "Date",
      "Reason",
    ];

    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.BIOMetricId || "N/A",
      item.UserName || "N/A",
      item.Designation || "N/A",
      formatDate(item.TerminationDt) || "N/A",
      item.Reason || "N/A",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 18,

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.setFontSize(12);
        doc.text("Employee Termination Report", 14, 10);

        doc.setFontSize(9);
        doc.text(`Generated: ${generatedDate}`, pageWidth - 14, 10, {
          align: "right",
        });

        doc.text(
          "RollCall Attendance System. Powered by Perennial Code IT Consultants",
          pageWidth / 2,
          pageHeight - 8,
          {
            align: "center",
          },
        );
      },
    });

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      doc.setFontSize(9);

      doc.text(`Page ${i} of ${totalPages}`, pageWidth - 14, pageHeight - 8, {
        align: "right",
      });
    }

    doc.save("Employee_Termination.pdf");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleReload = () => {
    window.location.reload();
  };

  const columns = [
    {
      title: "Biometric ID",
      dataIndex: "BIOMetricId",
      sorter: (a, b) => a.BIOMetricId?.length - b.BIOMetricId?.length,
      render: (text) => text || "N/A",
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
      render: (text) => (
        <span>{text?.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
      ),
    },
    // {
    //   title: "Mobile",
    //   dataIndex: "mobile",
    //   sorter: (a, b) => a.BIOMetricId?.length - b.BIOMetricId?.length,
    //   render: (text) => text || "N/A",
    // },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation?.length - b.Designation?.length,
      render: (text) => (
        <span>{text?.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
      ),
    },
    {
      title: "Date",
      dataIndex: "TerminationDt",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => formatDate(text),
    },
    {
      title: "Reason",
      dataIndex: "Reason",
      sorter: (a, b) => (a.Reason?.length || 0) - (b.Reason?.length || 0), // Handle cases where Reason might be null/undefined
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <Link
          className="dropdown-item mb-0"
          title="Rejoin"
          onClick={() => handleRejoinEmp(record.regid)}
        >
          <i className="fa-solid fa-person-walking-arrow-loop-left text-success"></i>
        </Link>
      ),
    },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Rejoin Employees
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your terminated employees</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set">
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="col-6 mb-2">
                      <label className="form-label"></label>
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
              </div>

              <div className="card-body">
                <div className="table-responsive brand-table">
                  {dataLoading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <div className="table-responsive brand-table">
                      <Table
                        columns={columns}
                        dataSource={filteredData}
                        pgno={true}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default RejoinEmployeeList;
